import {RuleBundleModelStrict} from '../../models/api/ruleBundleModel';
import {RuleBundleTypesEnum} from '../../models/api/ruleCommonTypes';
import {isLoadBalancingRule} from './ruleHelpers';

export function isLoadBalancingBundle(bundle: RuleBundleModelStrict) {
  return bundle.rules.some(isLoadBalancingRule);
}

export function isActiveBundle(bundle: RuleBundleModelStrict): boolean {
  return bundle.rules.every((rule) => rule.active);
}

export function isRegularRuleBundle(bundle: RuleBundleModelStrict) {
  return bundle.type === RuleBundleTypesEnum.SINGLE;
}
